import { FC } from 'node_modules/@types/react';
import { Backdrop, Button, Modal, Typography } from '@mui/material';
import SecondTypeButton from 'src/components/Items/button/SecondTypeButton';
import { useActions } from 'src/hooks/useActions';
import './styles.scss';
import './media.scss';

type Props = {
  id: number;
  open: boolean;
  onClose: () => void;
};

const CancelBookingModal: FC<Props> = ({ id, open, onClose }) => {
  const { actionOrder } = useActions();

  const handleSubmit = (type: string) => {
    if (type === 'guest') actionOrder(id, 'cancel 4 guest');
    else actionOrder(id, 'sorry no van');
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition BackdropComponent={Backdrop}>
      <div className='modal modal-450 cancel-booking-modal'>
        <div className='cancel-booking-modal__title'>Cancel booking</div>
        <div className='cancel-booking-modal__subtitle'>Refund polices apply</div>
        <p className='cancel-booking-modal__text'>Why do you want to cancel?</p>
        <p className='cancel-booking-modal__tips'>
          <b>Tips:</b> Van available but price o. a. issues?
          <br />
          → If time: ask office for help.
          <br />→ No time: just hit “My Van Is Unavailable”.
        </p>
        <div className='modal__fields'>
          <div className='modal__buttons cancel-booking-modal__buttons'>
            <Button onClick={() => handleSubmit('guest')}>
              <div>
                <h3>Guest Asked To Cancel</h3>
                <p>Confirms, deletes, frees up van</p>
              </div>
            </Button>
            <Button onClick={() => handleSubmit('host')}>
              <div>
                <h3>My Van Is Unavailable</h3>
                <p>Apologizes, deletes, blocks van</p>
              </div>
            </Button>
          </div>
          <SecondTypeButton
            children='Don’t Cancel'
            className='cancel-booking-modal__cancel-button'
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CancelBookingModal;
